
import { useState, useEffect, useRef } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import FormField from "layouts/applications/wizard/components/FormField";

import CrudService from "services/cruds-service";
import { Autocomplete } from "@mui/material";
import { MODULE_MASTER } from "utils/constant";
import ReactInputMask from "react-input-mask";
import MDModal from "components/MDModel";

const ContactModel = ({company_id, onSave}) => {
    const [firstName, setFirstName] = useState({ text: "", error: false, textError: "" });
    const [lastName, setLastName] = useState({ text: "", error: false, textError: "" });
    const [email, setEmail] = useState({ text: "", error: false, textError: "" });
    const [phone, setPhone] = useState({ text: false, error: false, textError: "" });
    const [position, setPosition] = useState("");
    const [department, setDepartment] = useState("");
    const [linkedin, setLinkedin] = useState("");
    const [company, setCompany] = useState();
    const [companyList, setCompanyList] = useState([]);
    const [contactType, setContactType] = useState();
    const [contactTypeList, setContactTypeList] = useState([]);
    const [contactBatch, setContactBatch] = useState();
    const [contactBatchList, setContactBatchList] = useState([]);
    const [statusType, setStatusType] = useState([]);
    const [statusEntity, setStatusEntity] = useState([]);
    const [openContactModel, setOpenContactModel] = useState(false)

    const containerRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (event) => {
        if (event.key === "Tab") {
            event.stopPropagation();
        }
        };

        if (containerRef.current) {
        containerRef.current.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            if (containerRef.current) {
                containerRef.current.removeEventListener("keydown", handleKeyDown);
            }
        };
    }, []);

    useEffect(() => {
        setCompany(company_id)
    },[company_id])

    useEffect(() => {
        if (openContactModel) {
          (async () => {
            const response = await CrudService.getCampaignCompanyByContact(localStorage.getItem('selectedCampaign') ?? '');
            setCompanyList(response.data);
          })();
    
          (async () => {
            try {
              const response = await CrudService.getStatusTypes(
                MODULE_MASTER.ENTITIES
              );
              setStatusEntity(response.data);
              setStatusType(response.default_id);
            } catch (err) {
              console.error(err);
              return null;
            }
          })();
          (async () => {
            try {
              const response = await CrudService.getCampaignContactTypes();
              setContactTypeList(response.data);
            } catch (err) {
              console.error(err);
              return null;
            }
          })();
          (async () => {
            try {
              const response = await CrudService.getCampaignContactBatches();
              setContactBatchList(response.data);
            } catch (err) {
              console.error(err);
              return null;
            }
          })();
        }
      }, [openContactModel]);

    const submitHandler = async (e) => {
        e.preventDefault();

        const data = {
            first_name: firstName.text,
            last_name: lastName.text,
            position: position,
            department: department,
            linkedin: linkedin,
            email: email.text != '' ? email.text : 'N/A',
            phone: phone.text != '' ? phone.text : 'N/A',
            contact_type_id: contactType?.contact_type_id,
            batch_id: contactBatch?.batch_id,
            company_id: company?.company_id,
            status_type_id: statusType?.id
        };
        try {
            let response = await CrudService.createCampaignContact(data);
            onSave()
        } catch (err) {
            if (err.hasOwnProperty("msg")) {
                setFirstName({ ...firstName, error: true, textError: err.msg });
            }
            console.error(err);
        }
        setOpenContactModel(false)
    };

    return (
        <div ref={containerRef}>
            <MDButton variant="contained" onClick={() => setOpenContactModel(true)} >Add Contact</MDButton>
            <MDModal
                open={openContactModel}
                onClose={() => setOpenContactModel(false)}
                footer={
                    <MDButton variant="gradient" color="dark" onClick={submitHandler}>
                        Save
                    </MDButton>
                }
            >
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        <MDBox px={3} my={2}>
                            <FormField
                                type="text"
                                label="First Name"
                                name="first_name"
                                value={firstName.text}
                                error={firstName.error}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setFirstName({ ...firstName, text: e.target.value })}
                            />
                            {firstName.error && (
                                <MDTypography variant="caption" color="error" fontWeight="light">
                                    {firstName.textError}
                                </MDTypography>
                            )}
                            <FormField
                                type="text"
                                label="Last Name"
                                name="last_name"
                                value={lastName.text}
                                error={lastName.error}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setLastName({ ...lastName, text: e.target.value })}
                            />
                            {lastName.error && (
                                <MDTypography variant="caption" color="error" fontWeight="light">
                                    {lastName.textError}
                                </MDTypography>
                            )}
                            <FormField
                                type="text"
                                label="Position"
                                name="position"
                                value={position}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setPosition(e.target.value)}
                            />
                            <FormField
                                type="text"
                                label="Department"
                                name="department"
                                value={department}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setDepartment(e.target.value)}
                            />
                            <FormField
                                type="text"
                                label="Linkedin"
                                name="linkedin"
                                value={linkedin}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setLinkedin(e.target.value)}
                            />
                            <FormField
                                type="text"
                                label="Email"
                                name="email"
                                value={email.text}
                                error={email.error}
                                onKeyDown={(e) => e.stopPropagation()}
                                onChange={(e) => setEmail({ ...email, text: e.target.value })}
                            />
                            {email.error && (
                                <MDTypography variant="caption" color="error" fontWeight="light">
                                    {email.textError}
                                </MDTypography>
                            )}
                            <ReactInputMask
                                mask="(999) 999-9999"
                                value={phone.text}
                                onChange={(e) => setPhone({ ...phone, text: e.target.value })}
                            >
                                {() => (
                                    <FormField
                                        label="Company Phone"
                                        placeholder="(123) 456-7890"
                                        onKeyDown={(e) => e.stopPropagation()}
                                    />
                                )}
                            </ReactInputMask>
                            <Autocomplete
                                sx={{ marginTop: '0.5rem' }}
                                defaultValue=""
                                options={contactTypeList}
                                getOptionLabel={(option) => (option.type_name ?? "")}
                                value={contactType ?? ""}
                                onChange={(event, newContactType) => {
                                    setContactType(newContactType);
                                }}
                                renderInput={(params) => (
                                    <FormField {...params} label="Contact Type" InputLabelProps={{ shrink: contactType }} required onKeyDown={(e) => e.stopPropagation()} />
                                )}
                            />
                            <Autocomplete
                                sx={{ marginTop: '0.5rem' }}
                                defaultValue=""
                                options={contactBatchList}
                                getOptionLabel={(option) => (option.batch_name ?? "")}
                                value={contactBatch ?? ""}
                                onChange={(event, newContactBatch) => {
                                    setContactBatch(newContactBatch);
                                }}
                                renderInput={(params) => (
                                    <FormField {...params} label="Contact Batch" InputLabelProps={{ shrink: contactBatch }} required onKeyDown={(e) => e.stopPropagation()} />
                                )}
                            />
                            <Autocomplete
                                        sx={{ marginTop: '0.5rem' }}
                                        defaultValue=""
                                        options={companyList}
                                        getOptionLabel={(option) => (option.company_name ?? "")}
                                        value={company ?? ""}
                                        onChange={(event, newCompany) => {
                                            setCompany(newCompany);
                                        }}
                                        renderInput={(params) => (
                                            <FormField {...params} label="Event Company" InputLabelProps={{ shrink: company }} onKeyDown={(e) => e.stopPropagation()} />
                                        )}
                                    />
                            <Autocomplete
                                sx={{ marginTop: '0.5rem' }}
                                defaultValue=""
                                options={statusEntity}
                                getOptionLabel={(option) => (option.attributes ? option.attributes?.StatusType.status_name : "")}
                                value={statusType ?? null}
                                onChange={(event, newStatus) => {
                                    setStatusType(newStatus);
                                }} // Custom equality function
                                renderInput={(params) => (
                                    <FormField {...params} label="Status" InputLabelProps={{ shrink: statusType }} required onKeyDown={(e) => e.stopPropagation()} />
                                )}
                            />

                            {/* <MDBox ml="auto" mt={4} mb={2} display="flex" justifyContent="flex-end">
                                <MDBox mx={2}>
                                    <MDButton
                                        variant="gradient"
                                        color="dark"
                                        size="small"
                                        px={2}
                                        mx={2}
                                        onClick={() =>
                                            navigate("/campaign/contact", {
                                                state: { value: false, text: "" },
                                            })
                                        }
                                    >
                                        Back
                                    </MDButton>
                                </MDBox>
                                <MDButton variant="gradient" color="dark" size="small" type="submit">
                                    Save
                                </MDButton>
                            </MDBox> */}
                        </MDBox>
                    </Grid>
                </Grid>
            </MDModal>
        </div>
    );
};

export default ContactModel;
